// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// #ifdef H5
import WechatJSSDK from "@/plugin/jweixin.js";
import request from "@/utils/request";

class AuthWechat {

    constructor() {
        //微信实例化对象
        this.instance = WechatJSSDK;
        //是否实例化
        this.status = false;

        this.initConfig = {};

    }

    isAndroid() {
        let u = navigator.userAgent;
        return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    }

    signLink() {
        if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
            window.entryUrl = location.href
        }
        return /(Android)/i.test(navigator.userAgent) ? location.href : window.entryUrl;
    }

    /**
     * 初始化wechat(分享配置)
     */
    wechat() {
        return new Promise((resolve, reject) => {
            let url = this.signLink();
            request.get("wechat/config", { url }).then(res => {
                let data = res.data;
                if (!data.jsApiList) {
                    data.jsApiList = ['wx-open-launch-weapp'];
                } else {
                    if (data.jsApiList.indexOf('wx-open-launch-weapp') === -1) {
                        data.jsApiList.push('wx-open-launch-weapp')
                    }
                }

                if (!data.openTagList) {
                    data.openTagList = ['wx-open-launch-weapp'];
                } else {
                    if (data.openTagList.indexOf('wx-open-launch-weapp') === -1) {
                        data.openTagList.push('wx-open-launch-weapp')
                    }
                }

                this.instance.config(data);
                this.initConfig = data;
                this.status = true;
                this.instance.ready(() => {
                    console.log('wxready')
                    resolve(this.instance);
                })
                this.instance.error(function (res) {
                  console.error('wxerr>>>>>>>', res)
                })
            }).catch(err => {
                console.log(err);
                this.status = false;
                reject(err);
            });
        });
    }

    /**
     * 验证是否初始化
     */
    verifyInstance() {
        let that = this;
        return new Promise((resolve, reject) => {
            if (that.instance === null && !that.status) {
                that.wechat().then(res => {
                    resolve(that.instance);
                }).catch(() => {
                    return reject();
                })
            } else {
                return resolve(that.instance);
            }
        })
    }

    toPromise(fn, config = {}) {
        return new Promise((resolve, reject) => {
            fn({
                ...config,
                success(res) {
                    resolve(res);
                },
                fail(err) {
                    reject(err);
                },
                complete(err) {
                    reject(err);
                },
                cancel(err) {
                    reject(err);
                }
            });
        });
    }

    clearAuthStatus() {

    }

    /**
     * 绑定事件
     * @param {Object} name 事件名
     * @param {Object} config 参数
     */
    wechatEvevt(name, config) {
        let that = this;
        return new Promise((resolve, reject) => {
            let configDefault = {
                fail(res) {
                    console.log(res, 11111);
                    if (that.instance) return reject({
                        is_ready: true,
                        wx: that.instance
                    });
                    that.verifyInstance().then(wx => {
                        return reject({
                            is_ready: true,
                            wx: wx
                        });
                    })
                },
                success(res) {
                    return resolve(res, 2222);
                }
            };
            Object.assign(configDefault, config);
            that.wechat().then(wx => {
                if (typeof name === 'object') {
                    name.forEach(item => {
                        wx[item] && wx[item](configDefault)
                    })
                } else {
                    wx[name] && wx[name](configDefault)
                }
            })
        });
    }

    isWeixin() {
        return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    }

}

export default new AuthWechat();
// #endif
